import type { FC } from 'react';

export const PipedriveLogo: FC<{ className?: string }> = ({ className }) => (
  <div className={className ?? 'w-8 h-8 flex items-center justify-center'}>
    <img
      src="/pipedrive-logo.png"
      alt="Pipedrive"
      className="w-full h-full object-contain"
    />
  </div>
);
